/**
 * Phone Number Utilities
 * Formatting and normalization for US phone numbers
 */

/**
 * Format a phone number for display
 * Converts "5555555555" → "(555) 555-5555"
 * Returns empty string if phone is null/undefined
 * Returns original if format is invalid
 */
export function formatPhoneNumber(phone: string | null | undefined): string {
  if (!phone) return '';

  // Remove all non-digit characters
  const cleaned = phone.replace(/\D/g, '');

  // If not 10 digits, return original (invalid format)
  if (cleaned.length !== 10) return phone;

  // Format as (XXX) XXX-XXXX
  return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
}

/**
 * Normalize phone number for storage
 * Converts "(555) 555-5555" → "5555555555"
 * Returns null if empty or invalid
 */
export function normalizePhoneNumber(phone: string): string | null {
  if (!phone) return null;

  // Remove all non-digit characters
  const cleaned = phone.replace(/\D/g, '');

  // Return null if not 10 digits (invalid US phone number)
  return cleaned.length === 10 ? cleaned : null;
}

/**
 * Validate US phone number
 * Returns true if phone number is valid 10-digit US format
 */
export function validateUSPhoneNumber(phone: string): boolean {
  if (!phone) return false;

  const cleaned = phone.replace(/\D/g, '');
  return cleaned.length === 10;
}
